/* CSS variables. You need to handle all places where `CSS variables` are marked. */

import { LINE_COLORS } from '@blocksuite/affine-model';
import {
  type AffineCssVariables,
  type AffineTheme,
  cssVar,
} from '@streamlain/theme';
export { cssVar } from '@streamlain/theme';
import { type AffineThemeKeyV2, cssVarV2 } from '@streamlain/theme/v2';
import { unsafeCSS } from 'lit';
export { cssVarV2 } from '@streamlain/theme/v2';
export const ColorVariables = [
  '--streamlain-brand-color',
  '--streamlain-primary-color',
  '--streamlain-secondary-color',
  '--streamlain-tertiary-color',
  '--streamlain-hover-color',
  '--streamlain-icon-color',
  '--streamlain-icon-secondary',
  '--streamlain-border-color',
  '--streamlain-divider-color',
  '--streamlain-placeholder-color',
  '--streamlain-quote-color',
  '--streamlain-link-color',
  '--streamlain-edgeless-grid-color',
  '--streamlain-success-color',
  '--streamlain-warning-color',
  '--streamlain-error-color',
  '--streamlain-processing-color',
  '--streamlain-text-emphasis-color',
  '--streamlain-text-primary-color',
  '--streamlain-text-secondary-color',
  '--streamlain-text-disable-color',
  '--streamlain-black-10',
  '--streamlain-black-30',
  '--streamlain-black-50',
  '--streamlain-black-60',
  '--streamlain-black-80',
  '--streamlain-black-90',
  '--streamlain-black',
  '--streamlain-white-10',
  '--streamlain-white-30',
  '--streamlain-white-50',
  '--streamlain-white-60',
  '--streamlain-white-80',
  '--streamlain-white-90',
  '--streamlain-white',
  '--streamlain-background-code-block',
  '--streamlain-background-tertiary-color',
  '--streamlain-background-processing-color',
  '--streamlain-background-error-color',
  '--streamlain-background-warning-color',
  '--streamlain-background-success-color',
  '--streamlain-background-primary-color',
  '--streamlain-background-secondary-color',
  '--streamlain-background-modal-color',
  '--streamlain-background-overlay-panel-color',
  '--streamlain-tag-blue',
  '--streamlain-tag-green',
  '--streamlain-tag-teal',
  '--streamlain-tag-white',
  '--streamlain-tag-purple',
  '--streamlain-tag-red',
  '--streamlain-tag-pink',
  '--streamlain-tag-yellow',
  '--streamlain-tag-orange',
  '--streamlain-tag-gray',
  ...LINE_COLORS,
  '--streamlain-tooltip',
  '--streamlain-blue',
];

export const SizeVariables = [
  '--streamlain-font-h-1',
  '--streamlain-font-h-2',
  '--streamlain-font-h-3',
  '--streamlain-font-h-4',
  '--streamlain-font-h-5',
  '--streamlain-font-h-6',
  '--streamlain-font-base',
  '--streamlain-font-sm',
  '--streamlain-font-xs',
  '--streamlain-line-height',
  '--streamlain-z-index-modal',
  '--streamlain-z-index-popover',
];

export const FontFamilyVariables = [
  '--streamlain-font-family',
  '--streamlain-font-number-family',
  '--streamlain-font-code-family',
];

export const StyleVariables = [
  '--streamlain-editor-width',

  '--streamlain-theme-mode',
  '--streamlain-editor-mode',
  /* --streamlain-palette-transparent: special values added for the sake of logical consistency. */
  '--streamlain-palette-transparent',

  '--streamlain-popover-shadow',
  '--streamlain-menu-shadow',
  '--streamlain-float-button-shadow',
  '--streamlain-shadow-1',
  '--streamlain-shadow-2',
  '--streamlain-shadow-3',

  '--streamlain-paragraph-space',
  '--streamlain-popover-radius',
  '--streamlain-scale',
  ...SizeVariables,
  ...ColorVariables,
  ...FontFamilyVariables,
] as const;

type VariablesType = typeof StyleVariables;
export type CssVariableName = Extract<
  VariablesType[keyof VariablesType],
  string
>;

export type CssVariablesMap = Record<CssVariableName, string>;

export const unsafeCSSVar = (
  key: keyof AffineCssVariables | keyof AffineTheme,
  fallback?: string
) => unsafeCSS(cssVar(key, fallback));

export const unsafeCSSVarV2 = (key: AffineThemeKeyV2, fallback?: string) =>
  unsafeCSS(cssVarV2(key, fallback));
